import Vue from "vue";
import VueRouter from "vue-router";
import testPage from './testPage.js'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "DefaultHome",
    component: () => import(/* webpackChunkName: "about" */ "../views/Home/index.vue"),
  },
  {
    path: "/index",
    name: "IndexHome",
    component: () => import(/* webpackChunkName: "about" */ "../views/Home/index.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: () => import(/* webpackChunkName: "about" */ "../views/Home/index.vue"),
    meta: {
      pageTitle: '首页',
    }
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About/index.vue"),
  },
  // 注册地区页
  {
    path: "/regionPager",
    name: "RegionPager",
    component: () => import(/* webpackChunkName: "about" */ "../views/About/components/RegionPager.vue"),
    meta: {
      pageTitle: '国家/地区',
    }
  },
  //区域列表
  {
    path: "/regionList",
    name: "RegionList",
    component: () => import("../views/RegionList/index.vue"),
    meta: {
      pageTitle: '国家/地区',
    }
  },
  // 优惠码页面
  {
    path: "/discountCode",
    name: "DiscountCodepager",
    component: () => import(/* webpackChunkName: "about" */ "../views/About/components/DiscountCodePager.vue"),
    meta: {
      pageTitle: '充值卡',
    }
  },
  // 充值成功页
  {
    path: "/rechargesuccess",
    name: "RechargeSuccess",
    component: () => import(/* webpackChunkName: "about" */ "../views/About/components/RechargeSuccess.vue"),
    meta: {
      pageTitle: '充值成功',
    }
  },
  {
    path: '/packages',
    name: 'Packages',
    // component: () => import('../views/packages/newPackageList.vue'),
    component: () => import('../views/packages/packages.vue'),
    meta: {
      pageTitle: '套餐页面',
    }
  },
  {
    path: '/selectPackages',
    name: 'SelectPackages',
    component: () => import('../views/packages/SelectPackage.vue'),
    meta: {
      pageTitle: '选择套餐页面',
    }
  },
  {
    path: '/packsges/detail',
    name: 'PackageDetail',
    component: () => import('../views/packages/detail.vue'),
    meta: {
      pageTitle: '套餐详情',
    }
  },
  // 套餐购买结算
  {
    path: '/packsges/settlement',
    name: 'settlement',
    component: () => import('../views/packages/settlement'),
    meta: {
      pageTitle: '支付订单',
    }
  },
  {
    path: '/packages/buy/confirm',
    name: 'PackageBuyConfirm',
    component: () => import('../views/packages/confirm.vue'),
    meta: {
      pageTitle: '支付订单',
    }
  },
  {
    path: '/pay/jump/:id?',
    name: 'PayJump',
    component: () => import('../views/pay/jump')
  },
  {
    path: '/pay/result',
    name: 'PayResult',
    component: () => import('../views/pay/result'),
    meta: {
      pageTitle: '支付结果',
    }
  },
  {
    path: '/pay/fail',
    name: 'PayFail',
    component: () => import('../views/pay/fail'),
    meta: {
      pageTitle: '支付失败',
    }
  },
  {
    path: '/order',
    name: 'OrderList',
    component: () => import('../views/order/index'),
    meta: {
      pageTitle: '我的流量',
    }
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    component: () => import('../views/order/flowDetail'),
    meta: {
      pageTitle: '流量详情',
    }
  },
  {
    path: '/orderList/orderDetail',
    name: 'OrderListDetail',
    component: () => import('../views/order/orderDetail'),
    meta: {
      pageTitle: '订单详情详情',
    }
  },
  {
    path: '/order/invalidFlow',
    name: 'invalidFlow',
    component: () => import('../views/order/invalidFlow'),
    meta: {
      pageTitle: '失效流量包',
    }
  },
  // 快速登录注册页
  {
    path: '/qs',
    name: 'QuickLogin',
    component: () => import('../views/Registerlogin/index'),
    meta: {
      pageTitle: '注册登录',
    }
  },
  {
    path: '/qs/registerCountry',
    name: 'RegisterCountry',
    component: () => import('../views/Registerlogin/registerCountry'),
    meta: {
      pageTitle: '选择注册国家',
    }
  },
  {
    path: '/qs/forgotPwd',
    name: 'ForgotPwd',
    component: () => import('../views/Registerlogin/forgotPwd'),
    meta: {
      pageTitle: '忘记密码',
    }
  },
  // 优惠券页面
  {
    path: '/Coupons',
    name: 'Coupons',
    component: () => import('../views/Coupons/index'),
    meta: {
      pageTitle: '优惠券',
    }
  },
  {
    path: '/Coupons/couponGoodsList',
    name: 'CouponGoodsList',
    component: () => import('../views/Coupons/couponGoodsList'),
    meta: {
      pageTitle: '优惠券可用套餐',
    }
  },
  // 数字服务列表
  {
    path: '/dp',
    name: 'DigitalList',
    component: () => import('../views/Digital/index'),
    meta: {
      pageTitle: '数字服务列表',
    }
  },
  {
    path: '/dp/detail',
    name: 'DigitalDetail',
    component: () => import('../views/Digital/detail'),
    meta: {
      pageTitle: '数字服务详情',
    }
  },
  {
    path: '/dp/orderList',
    name: 'DigOrderList',
    component: () => import('../views/Digital/orderList'),
    meta: {
      pageTitle: '数字服务订单列表',
    }
  },
  {
    path: '/pl',
    name: 'PublicPackageList',
    component: () => import('../views/ViewPublicPackage/index'),
    meta: {
      pageTitle: '查看套餐列表',
    }
  },
  {
    path: '/ottocast',
    name: 'PublicPackageList',
    component: () => import('../views/ViewPublicPackage/index'),
    meta: {
      pageTitle: '查看套餐列表',
    }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('../views/Feedback/index.vue'),
    meta: {
      pageTitle: '用户反馈',
    }
  },
  {
    path: '/introAPP',
    name: 'IntroAPP',
    component: () => import('../views/IntroAPP/index.vue'),
    meta: {
      pageTitle: 'APP介绍页',
    }
  },
  {
    path: '/netError',
    name: 'NetError',
    component: () => import('../views/Other/netError'),
    meta: {
      pageTitle: '无网络',
    }
  },
  {
    path: '/loadFail',
    name: 'LoadFail',
    component: () => import('../views/Other/loadFail'),
    meta: {
      pageTitle: '加载失败',
    }
  },
  {
      path: '*',
      name: '404',
      component: () => import('../views/Other/404'),
      meta: {
        pageTitle: '404',
      }
  },
  // 调试页面，请勿删除
  ...testPage,
];

const router = new VueRouter({
  mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

export default router;
